import { ErrorHandler, inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { OAuthErrorEvent, OAuthEvent } from '@ortho-next/auth-core';
import { PAGE } from '../app.routes';
import { APP_CONFIG } from './app-config';
import { MonitoringService } from './monitoring.service';


/**
 * This service handles generic errors.
 */
@Injectable({ providedIn: 'root' })
export class MonitoringErrorHandler implements ErrorHandler {

	private readonly _router = inject(Router);
	private readonly configs = inject(APP_CONFIG);
	private readonly monitorSrv = inject(MonitoringService);

	handleError(error: any): void {
		if (error instanceof OAuthEvent === false && error instanceof OAuthErrorEvent === false) {
			this.monitorSrv.logError(error);
			if (this.configs.envName != 'default') {
				this._router.navigate([PAGE.ERROR], { queryParams: { error: error } });
			}
		}
	}

}
